import { render, staticRenderFns } from "./AlertClose.vue?vue&type=template&id=5883ba20&"
import script from "./AlertClose.vue?vue&type=script&lang=js&"
export * from "./AlertClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports